export default "__VITE_ASSET__BMkn4o59__"